import * as keyword from './types';

const getters = {
  [keyword.BENEFITS]: state => state.benefits,
  [keyword.BENEFIT]: state => state.benefit,
  [keyword.SECTIONS]: state => state.sections,
  [keyword.SECTION]: state => state.section,
  [keyword.SECTION_COUNT]: state => state.sections.content.length,
  [keyword.STORES]: state => state.stores,
  [keyword.TEMP_KEYWORDBENEFIT]: state => state.keywordBenefit,
  [keyword.STOREKEYWORD]: state => state.storeKeyword,
};

export default getters;
